import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const prepareImagesToServer = (body: IPropertyForm) => {
  if (body.images_property) {
    return body.images_property.map((x, i: number) => {
      return x.id;
      // return {
      //   order: i + 1,
      //   comment: x.comment,
      //   image: x.isNewFile ? x.file : x.id
      // };
    });
  }
  return [];
};

export default prepareImagesToServer;
